import URLSearchParams from './url-search-params';
/**
 * Wraps URLSearchParams and pushes changes in search string to a parent
 * URL instance.
 */
export default class URLSearchParamsWrapper extends URLSearchParams {
    constructor(url, init) {
        super();
        this.url = url;
        this.params = init.params;
    }
    append(name, value) {
        super.append(name, value);
        this.url.search = this.toString();
    }
    delete(name) {
        super.delete(name);
        this.url.search = this.toString();
    }
    set(name, value) {
        super.set(name, value);
        this.url.search = this.toString();
    }
    sort() {
        super.sort();
        this.url.search = this.toString();
    }
}
//# sourceMappingURL=search-params-wrapper.js.map